<template>
    <section :class="`message ${this.isError ? 'error' : ''} flow__panel`">
        <div class="message__main">
            <h2 v-if="header"
                class="message__title">
                {{ this.header }}
            </h2>
            <p class="message__text">
                {{ this.message }}
            </p>
        </div>
        <div class="message__buttons">
            <hh-btn v-if="showBack"
                    type="cancel"
                    class="message__button message__button--back"
                    icon-class="fas fa-undo"
                    icon-location="pre"
                    text="Back"
                    @click="onBackClick" />
            <hh-btn v-if="showOk"
                    class="message__button message__button--ok"
                    text="OK"
                    @click="onBackClick" />
        </div>
    </section>
</template>

<script>

import AnalyticsPage from './analytics-page'

export default {

    props: {
        title: {
            type: String,
            default: null,
        },
        text: {
            type: String,
            default: null,
        },
        showOk: {
            type: Boolean,
            default: false,
        },
        showBack: {
            type: Boolean,
            default: false,
        },
        isError: {
            type: Boolean,
            default: false,
        },
    },

    mixins: [
        AnalyticsPage,
    ],

    data() {
        return {
            header: this.title ? this.title : this.$route.params.title,
            message: this.text ? this.text : this.$route.params.text,
            back: this.$route.params.back ? this.$route.params.back : -1,
        }
    },

    methods: {

        onBackClick() {
            this.$router.go(this.back)
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.

.message {
    @include message-page;
}

</style>
